import {
  FETCH_ADDRESSES,
  FETCH_ADDRESSES_SUCCESS,
  FETCH_ADDRESSES_FAILED,
  EDIT_ADDRESS
} from "../store/types";
import store from '../store/store';
import { getSupabase } from '../config/configureSupabase';

export const fetchAddresses = () => async (dispatch) => {
  dispatch({
    type: FETCH_ADDRESSES,
    payload: null
  });

  const supabase = getSupabase();
  const userInfo = store.getState().auth?.profile;
  const uid = userInfo?.uid || userInfo?.id;

  if (supabase && uid) {
    try {
      const { data, error } = await supabase
        .from('saved_addresses')
        .select('*')
        .eq('user_id', uid);

      if (!error && data) {
        dispatch({
          type: FETCH_ADDRESSES_SUCCESS,
          payload: data
        });
        return;
      }
    } catch (e) {}
  }

  dispatch({
    type: FETCH_ADDRESSES_SUCCESS,
    payload: []
  });
};

export const editAddress = (uid, address, method) => async (dispatch) => {
  dispatch({
    type: EDIT_ADDRESS,
    payload: { method, address }
  });

  const supabase = getSupabase();
  if (supabase && uid) {
    try {
      if (method === 'Add') {
        await supabase.from('saved_addresses').insert([{ ...address, user_id: uid }]);
      } else if (method === 'Delete') {
        await supabase.from('saved_addresses').delete().eq('id', address.id);
      }
    } catch (e) {}
  }
};